import React, { ReactNode, CSSProperties } from "react";

import classes from "./Table.module.scss";
import TableSortContext from "./TableSortContext";
import { ISort, TSortType } from "./useTableSort";

interface IProps {
  children: ReactNode;
  hover?: boolean;
  className?: string;
  style?: CSSProperties;
  containerStyles?: CSSProperties;
  containerClassName?: string;
  bordered?: boolean;
  condensed?: boolean;
  removeGap?: boolean;
  removeBorder?: boolean;
  stickyHeader?: boolean;
  sortContext?: { sort: ISort; onSort: (key: string, type?: TSortType | any) => void };
}

const Table: React.FC<IProps> = ({
  children,
  hover,
  className,
  style,
  containerClassName,
  bordered,
  containerStyles,
  condensed,
  removeGap,
  removeBorder,
  stickyHeader,
  sortContext
}) => {
  const tableClassNames = [classes.Table];
  if (hover) {
    tableClassNames.push(classes.Hover);
  }
  if (removeGap) {
    tableClassNames.push(classes.RemoveGap);
  }
  if (className) {
    tableClassNames.push(className);
  }
  const containerClassNames = [classes.Container];
  if (containerClassName) {
    containerClassNames.push(containerClassName);
  }
  if (bordered) {
    tableClassNames.push(classes.Bordered);
  }
  if (condensed) {
    tableClassNames.push(classes.Condensed);
  }
  if (removeBorder) {
    tableClassNames.push(classes.RemoveBorder);
  }
  if (stickyHeader) {
    containerClassNames.push(classes.DisableOverflow)
    tableClassNames.push(classes.StickyHeader);
  }
  
  const content = (
    <div style={containerStyles} className={containerClassNames.join(" ")}>
      <table style={style} className={tableClassNames.join(" ")}>
        {children}
      </table>
    </div>
  );

  if (sortContext) {
    return (
      <TableSortContext.Provider value={sortContext as any}>
        {content}
      </TableSortContext.Provider>
    );
  }

  return content;
};

export default Table;
